import React from "react";
import { RetailMatchMetricLevel } from "../../../../Enums/RetailMatchMetricLevel";
import { IRetailMatchOverview } from "../../../../Models/Models";
import { getRetailMatchIndexColor } from "../../../../Util/ColorUtil";
import { getRetailMatchMetricVerbiage } from "../../../../Util/RetailMatch/RetailMatchUtil";
import {
    BreakoutContainer,
    BreakoutItem,
    BreakoutItemBarInner,
    BreakoutItemBarOuter,
    BreakoutItemHeader,
    BreakoutItemVerbiage,
    BreakoutVerticalBreak,
} from "../Styled/RetailMatchIntroStyles";

interface IRetailMatchIntroTextProps {
  overview: IRetailMatchOverview;
  isSharing?: boolean;
}

const RetailMatchIntroTextIndexBreakout = ({
    overview,
    isSharing,
}: IRetailMatchIntroTextProps): JSX.Element => {
    return (
        <BreakoutContainer
            style={{
                maxWidth: `${isSharing && "initial"}`,
                margin: `${isSharing && "0px"}`,
            }}
        >
            <BreakoutItem>
                <BreakoutItemHeader>Ideal Customer Count</BreakoutItemHeader>
                <BreakoutItemVerbiage value={overview?.coreCustomerCountIndex}>
                    <span>
                        <b
                            style={{
                                color: getRetailMatchIndexColor(
                                    overview?.coreCustomerCountIndex
                                ),
                            }}
                        >
                            {getRetailMatchMetricVerbiage(
                                overview?.coreCustomerCountIndex,
                                RetailMatchMetricLevel.Average
                            )}
                        </b>
                    </span>
                </BreakoutItemVerbiage>
                <BreakoutItemBarOuter>
                    <BreakoutItemBarInner
                        value={overview?.coreCustomerCountIndex}
                    ></BreakoutItemBarInner>
                </BreakoutItemBarOuter>
            </BreakoutItem>
            <BreakoutVerticalBreak />
            <BreakoutItem>
                <BreakoutItemHeader>Ideal Customer Ratio</BreakoutItemHeader>
                <BreakoutItemVerbiage value={overview?.coreCustomerPerHouseholdIndex}>
                    <span>
                        <b
                            style={{
                                color: getRetailMatchIndexColor(
                                    overview?.coreCustomerPerHouseholdIndex
                                ),
                            }}
                        >
                            {getRetailMatchMetricVerbiage(
                                overview?.coreCustomerPerHouseholdIndex,
                                RetailMatchMetricLevel.Comparable
                            )}
                        </b>
                    </span>
                </BreakoutItemVerbiage>
                <BreakoutItemBarOuter>
                    <BreakoutItemBarInner
                        value={overview?.coreCustomerPerHouseholdIndex}
                    ></BreakoutItemBarInner>
                </BreakoutItemBarOuter>
            </BreakoutItem>
            <BreakoutVerticalBreak />
            <BreakoutItem>
                <BreakoutItemHeader>Ideal Customer Similarity</BreakoutItemHeader>
                <BreakoutItemVerbiage value={overview?.coreCustomerCorrelationIndex}>
                    <span>
                        <b
                            style={{
                                color: getRetailMatchIndexColor(
                                    overview?.coreCustomerCorrelationIndex
                                ),
                            }}
                        >
                            {getRetailMatchMetricVerbiage(
                                overview?.coreCustomerCorrelationIndex,
                                RetailMatchMetricLevel.Similarity
                            )}
                        </b>
                    </span>
                </BreakoutItemVerbiage>
                <BreakoutItemBarOuter>
                    <BreakoutItemBarInner
                        value={overview?.coreCustomerCorrelationIndex}
                    ></BreakoutItemBarInner>
                </BreakoutItemBarOuter>
            </BreakoutItem>
        </BreakoutContainer>
    );
};

export default RetailMatchIntroTextIndexBreakout;
